import { DesignTokens } from '../brands';
import sharedDsTokens from '../default/ds-tokens';

const dsTokens: DesignTokens = {
  ...sharedDsTokens,
  colors: {
    ...sharedDsTokens.colors,
    'brand-1': '#613A53',
    'brand-2': '#A98862',
    'brand-3': '#F1F2F2',
    'dark-dark': '#383840',
    'dark-light': '#383840',
    'light-dark-1': '#F5F5F5',
    'light-dark-2': '#FFFFFF',
    actionNavigationStandardStatic: '#A98862',
    actionNavigationStandardHighlight: '#8B6A44',
    actionNavigationStandardDisabled: '#00000029',
    actionNavigationAltHighlight: '#C7A67C',
    actionNavigationAltDisabled: '#ffffff3d',
    actionConversionStatic: '#A2577C',
    actionConversionHighlight: '#613A53',
    actionConversionDisabled: '#00000029',
    nonInteractiveEmphasis: '#613A53',
  },
  fonts: {
    primary: "'Sofia Pro', Helvetica, Arial, sans-serif",
    secondary: "'Sofia Pro', Helvetica, Arial, sans-serif",
  },
};

export default dsTokens;
